import { SETTINGS_BILLING_PAGE } from 'subapps/settings/types'
import { selectCurrentPage } from 'selectors/location'
import { redirect } from 'redux-first-router'
import { ALLOWED_EXPIRED_BILLING } from 'constants/billing'

export default function doRedirectToBilling(options = {}) {
  return (dispatch, getState) => {
    const {
      withRedirect = false,
      ignoreAllowed = false,
      query = {},
      payload = {},
    } = options
    const state = getState()
    const currentPageType = selectCurrentPage(state)
    if (!ALLOWED_EXPIRED_BILLING.includes(currentPageType) || ignoreAllowed) {
      const action = {
        type: SETTINGS_BILLING_PAGE,
        meta: {
          query,
        },
        payload,
      }
      return dispatch(withRedirect ? redirect(action) : action)
    }
    return null
  }
}
